export const parseGraphqlError = error => {
  return error.toString().split(':')[2];
};
